// extracted by mini-css-extract-plugin
export var container = "_p4-0";
export var dotAnimation = "_p4-2";
export var dotsLoading = "_p4-1";